import { NEW_VERIFICATE, UPDATE_VERIFICATE, FIND_VERIFICATE } from './../constants';
import { handleActions } from "redux-actions"

export const verificates  = handleActions(
  {
    [ NEW_VERIFICATE ]: (state, action) => action.payload,
    [ UPDATE_VERIFICATE ]: (state, action) => state,
    [ FIND_VERIFICATE ]: (state, action) => state
  }, {}
)